// Component: اختيار نوع الطلب (خدمات / باقات)
import { useLanguage } from "../../../i18n/LanguageContext";

export default function RequestTypeSelector({ requestType, onChange }) {
  const { t } = useLanguage();

  return (
    <div className="request-type-box">

      {/* العنوان */}
      <label className="request-label">
        {t.request.labels.requestType}
      </label>

      {/* خدمات */}
      <label className="request-option">
        <input
          type="radio"
          name="requestType"
          value="services"
          checked={requestType === "services"}
          onChange={onChange}
        />
        {t.request.requestTypes.services}
      </label>

      {/* باقات */}
      <label className="request-option">
        <input
          type="radio"
          name="requestType"
          value="packages"
          checked={requestType === "packages"}
          onChange={onChange}
        />
        {t.request.requestTypes.packages}
      </label>

    </div>
  );
}

